var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailBs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3578 4.21533H4.63904C3.85608 4.21617 3.10543 4.52757 2.55179 5.08121C1.99815 5.63484 1.68675 6.3855 1.68591 7.16846V19.8247C1.68675 20.6077 1.99815 21.3583 2.55179 21.912C3.10543 22.4656 3.85608 22.777 4.63904 22.7778H22.3578C23.1407 22.777 23.8914 22.4656 24.445 21.912C24.9987 21.3583 25.3101 20.6077 25.3109 19.8247V7.16846C25.3101 6.3855 24.9987 5.63484 24.445 5.08121C23.8914 4.52757 23.1407 4.21617 22.3578 4.21533ZM21.61 9.10012L14.0163 15.0064C13.8682 15.1215 13.686 15.184 13.4984 15.184C13.3109 15.184 13.1286 15.1215 12.9806 15.0064L5.38681 9.10012C5.29759 9.03274 5.22265 8.9483 5.16635 8.85172C5.11004 8.75513 5.0735 8.64831 5.05883 8.53747C5.04416 8.42664 5.05167 8.31399 5.08092 8.20608C5.11016 8.09817 5.16056 7.99715 5.22919 7.90889C5.29781 7.82063 5.3833 7.74688 5.48067 7.69194C5.57804 7.637 5.68536 7.60196 5.79639 7.58886C5.90742 7.57575 6.01995 7.58485 6.12744 7.61561C6.23492 7.64637 6.33523 7.69819 6.42251 7.76805L13.4984 13.2714L20.5743 7.76805C20.7512 7.63443 20.9737 7.57583 21.1935 7.60491C21.4133 7.634 21.6128 7.74843 21.7489 7.92347C21.885 8.0985 21.9467 8.32008 21.9207 8.54027C21.8947 8.76046 21.7831 8.96157 21.61 9.10012Z",
    fill: "#FF5467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailBs);
export default __webpack_public_path__ + "static/media/EmailBS.6ae71afcc5b60cb61c6301d2f598d09a.svg";
export { ForwardRef as ReactComponent };